import script from "./MortgagePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MortgagePage.vue?vue&type=script&setup=true&lang=ts"

import "./MortgagePage.vue?vue&type=style&index=0&id=e0798c68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0798c68"]])

export default __exports__